import React from "react";
import type { SolutionFeedbackFieldProps } from "../../../../../../../../types/feedback/feedback";
import CustomSelect from "../../../../../../../common/custom-select";

const PriorityField: React.FC<SolutionFeedbackFieldProps> = ({ formState, setFormState }) => {
  if (formState.impactResponse !== "yes" && formState.impactResponse !== "partially") return null;
  return (
    <div>
      <label className="block text-[16px] font-medium text-brand-textSubheading mb-[24px]">
        How urgent is this problem?
      </label>
      <CustomSelect
        options={[
          { label: "Not urgent", value: "not_urgent" },
          { label: "Important", value: "important" },
          { label: "High priority", value: "high_priority" },
          { label: "Critical now", value: "critical_now" },
        ]}
        selectedValue={formState.priorityLevel}
        onChange={(value) => setFormState((prev) => ({ ...prev, priorityLevel: value }))}
        placeholder="Select urgency level..."
      />
    </div>
  );
};

export default PriorityField;
